var _rect, _rect2, _path, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCmndMt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 90,
    viewBox: "0 0 157 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 157,
    height: 90,
    rx: 6.85851,
    fill: "#ECECEC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4029,
    y: 14.4796,
    width: 60.6978,
    height: 61.0408,
    rx: 6.85851,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.7518 44.9998C53.2718 44.9998 57.7456 40.526 57.7456 35.006C57.7456 29.4859 53.2718 25.0121 47.7518 25.0121C42.2318 25.0121 37.7579 29.4859 37.7579 35.006C37.7579 40.526 42.2318 44.9998 47.7518 44.9998ZM54.7475 47.4983H53.4436C51.7103 48.2947 49.7818 48.7475 47.7518 48.7475C45.7218 48.7475 43.8011 48.2947 42.06 47.4983H40.7561C34.9628 47.4983 30.2626 52.1985 30.2626 57.9918V61.2398C30.2626 63.3088 31.9412 64.9875 34.0103 64.9875H61.4933C63.5623 64.9875 65.241 63.3088 65.241 61.2398V57.9918C65.241 52.1985 60.5408 47.4983 54.7475 47.4983Z",
    fill: "#DCDCDC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 86.1007,
    y: 16.2818,
    width: 53.4964,
    height: 17.4892,
    rx: 3.42926,
    fill: "#DCDCDC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 86.1007,
    y: 42.771,
    width: 35.3213,
    height: 10.9736,
    rx: 3.42926,
    fill: "#DCDCDC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 86.1007,
    y: 62.7446,
    width: 53.4964,
    height: 10.9736,
    rx: 3.42926,
    fill: "#DCDCDC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmndMt);
export default __webpack_public_path__ + "static/media/CMND_MT.e7b241e0ca75f0523b47e057b3035abe.svg";
export { ForwardRef as ReactComponent };